import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ErrorPopupScreenState {
  showErrorPopup: boolean,
  errorMessage: string
}

const initialState: ErrorPopupScreenState = {
  showErrorPopup: false,
  errorMessage: ''
};

const errorPopupScreenSlice = createSlice({
  name: 'errorPopupScreen',
  initialState,
  reducers: {
    updateShowError: (state, action: PayloadAction<ErrorPopupScreenState>) => action.payload,
    updateShowErrorPopup: (state, action: PayloadAction<boolean>) => {
      state.showErrorPopup = action.payload
    }
  }
})

export const {updateShowError, updateShowErrorPopup} = errorPopupScreenSlice.actions;

export default errorPopupScreenSlice.reducer;
